import { t } from '@lingui/macro';
import { object, string, mixed, ObjectSchema, boolean } from 'yup';

import { ApplicationFormValues } from './ApplicationForm.types';

export const MAX_FILE_SIZE = 10 * 1024 * 1024;
export const ALLOWED_FILE_TYPES = [
  {
    type: 'application/pdf',
    extension: '.pdf',
  },
  {
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    extension: '.docx',
  },
  { type: 'application/msword', extension: '.doc' },
  { type: 'text/rtf', extension: '.rtf' },
];
export const ALLOWED_FILE_TYPE_EXTENSIONS = ALLOWED_FILE_TYPES.map(
  (fileType) => fileType.extension
).join(', ');

export const isAllowedFileType = (file?: File): boolean =>
  ALLOWED_FILE_TYPES.some((fileType) => fileType.type === file?.type);

export const isWithinAllowedFileSize = (file?: File): boolean => (file?.size || 0) <= MAX_FILE_SIZE;

export const getApplicationFormValidation = (): ObjectSchema<ApplicationFormValues> => {
  return object({
    firstName: string().required(t({ id: 'vacancies.application.form.required' })),
    lastName: string().required(t({ id: 'vacancies.application.form.required' })),
    email: string()
      .email(t({ id: 'vacancies.application.form.valid.email' }))
      .test('email-domain', t({ id: 'vacancies.application.form.valid.email' }), (value) => {
        const containsDotInEmailDomain = /@.+\..+$/;
        return !!value && containsDotInEmailDomain.test(value);
      })
      .required(t({ id: 'vacancies.application.form.required' })),
    linkedIn: string().url(t({ id: 'vacancies.application.form.valid.linkedIn' })),
    motivation: string(),
    cv: mixed<File>()
      .required(t({ id: 'vacancies.application.form.required.cv' }))
      .test({
        message: t({ id: 'vacancies.application.form.cv.invalidFileType' }),
        test: isAllowedFileType,
      })
      .test({
        message: t({ id: 'vacancies.application.form.cv.fileTooLarge' }),
        test: isWithinAllowedFileSize,
      }),
    cvAgreement: boolean(),
  });
};
